<template>
  <div class="dialog-wrap">
    <el-dialog
      title="优惠券选择"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      append-to-body
      @close="handleClose"
      width="980px"
    >
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item label="优惠券名称" prop="name">
          <el-input
            v-model="query.name"
            size="mini"
            placeholder="输入优惠券名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="query.status" size="mini" placeholder="请选择">
            <el-option
              v-for="item in filter.status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="handleSearch"
            >搜索</el-button
          >
          <el-button
            class="submit"
            size="mini"
            @click="handleFormReset('searchForm')"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        class="result"
        ref="multipleTable"
        :data="results"
        tooltip-effect="dark"
        size="mini"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" fixed="left" width="55">
        </el-table-column>
        <el-table-column
          prop="id"
          label="ID"
          fixed="left"
          width="40"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="优惠券名称"
          fixed="left"
          min-width="160"
          align="left"
        >
        </el-table-column>
        <el-table-column
          prop="description"
          label="优惠券简介"
          min-width="160"
          align="left"
        >
        </el-table-column>
        <el-table-column label="使用门槛" min-width="160" align="left">
          <template slot-scope="scope">
            <span v-if="scope.row.min_cost"
              >订单满{{ scope.row.min_cost }}元可用</span
            >
            <span v-else>无使用门槛</span>
          </template>
        </el-table-column>
        <el-table-column label="优惠内容" min-width="160" align="left">
          <template slot-scope="scope">
            <span v-if="scope.row.discount_amount"
              >减免{{ scope.row.discount_amount }}元</span
            >
            <span v-else>打{{ scope.row.discount_rate }}折</span>
          </template>
        </el-table-column>
        <el-table-column label="适用商品" min-width="160" align="left">
          <template slot-scope="scope">
            <span v-if="scope.row.ref_ids"
              >包含{{ scope.row.ref_ids.split(",").length }}份商品</span
            >
            <span v-else-if="scope.row.ref_group_ids"
              >包含{{ scope.row.ref_group_ids.split(",").length }}个商品组</span
            >
            <span v-else>全部商品可用</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="circulation"
          label="发放总量"
          min-width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="receive_count"
          label="已领取"
          min-width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="used_count"
          label="已使用"
          min-width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column label="有效期" min-width="180" align="center">
          <template slot-scope="scope">
            <span
              >{{ $moment(scope.row.start_time).format("YYYY-MM-DD") }} 至
              {{ $moment(scope.row.end_time).format("YYYY-MM-DD") }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="状态" width="120" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status == 1 ? 'success' : 'danger'">{{
              scope.row.status == 1 ? "正常" : "下线"
            }}</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination
          background
          small
          layout="total, prev, pager, next, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { couponList } from "@/api/operation";

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      query: {
        name: "",
        status: "",
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
      },
      pageTotal: 10,
      filter: {
        status: [
          { label: "全部", value: "" },
          { label: "正常", value: "1" },
          { label: "下线", value: "0" },
        ],
        types: [
          { label: "全部", value: "" },
          { label: "统考", value: "1" },
          { label: "非统考", value: "0" },
        ],
      },
      results: [],
      selections: [],
      countSelections: [],
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;

      if (val) {
        this.fetchList();
      }
    },
    rows(val) {
      this.countSelections = val;
    },
  },
  methods: {
    // 列表请求
    fetchList() {
      let params = { ...this.query };
      couponList(params).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;

        this.$nextTick(this.setRowSelection);
      });
    },
    // 设置选中行
    setRowSelection() {
      if (this.results.length) {
        this.results.forEach((row) => {
          if (this.rows.find((item) => item.id === row.id)) {
            this.$refs.multipleTable.toggleRowSelection(row, true);
          }
        });
      }
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },
    // 选择
    handleSelectionChange(val) {
      this.selections = val;
      this.diffSelection();
    },
    handleSubmit() {
      this.$emit("submit", {
        rows: this.countSelections.map((v) => ({ id: v.id, name: v.name })),
      });
      this.handleClose();
    },
    handleClose() {
      // 检索条件重置
      this.query = {
        name: "",
        status: "",
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
      };
      this.$emit("close");
    },
    // 选中项差异化计算
    diffSelection() {
      let diffs = [];
      // 减
      this.countSelections.forEach((item, index) => {
        if (!this.selections.find((v) => v.id === item.id)) {
          if (this.results.find((v2) => v2.id === item.id)) {
            diffs.push(item);
          }
        }
      });
      if (diffs.length) {
        this.countSelections = this.countSelections.filter(
          (item) => !diffs.find((v) => v.id === item.id)
        );
      }
      // 加
      this.selections.forEach((item) => {
        if (!this.countSelections.find((v) => v.id === item.id)) {
          this.countSelections.push(item);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.dialog-wrap {
  .search-wrap {
    margin-bottom: -10px;
  }
  .result {
    margin-top: 10px;
  }
  .footer {
    margin-top: 10px;
  }
}
</style>
